import { userInfoSync } from 'hub-http/userInfo';
import { determineStatus } from './determineAccessInfo';

// TODO: Temporary for scope-to-gyro-grant transition. Remove once migration to gyro grant checks is complete.
export function buildAccessInfoFromScopeChecks({
  scopesToCheck,
  requireAnyScope = false,
  scopesRequiredForVisibility = [],
  additionalCheck
}) {
  const userScopes = userInfoSync().user.scopes;
  const scopeHasAccess = requireAnyScope ? scopesToCheck.length === 0 || scopesToCheck.some(scope => userScopes.includes(scope)) : scopesToCheck.every(scope => userScopes.includes(scope));
  const hasAccess = additionalCheck ? additionalCheck.operator === 'AND' ? scopeHasAccess && additionalCheck.isSatisfied : scopeHasAccess || additionalCheck.isSatisfied : scopeHasAccess;
  const missingScopes = hasAccess ? [] : scopesToCheck.filter(scope => !userScopes.includes(scope));
  const hasVisibilityScopesDefined = scopesRequiredForVisibility.length > 0;
  const isVisible = hasVisibilityScopesDefined ? scopesRequiredForVisibility.every(scope => hasAccess || userScopes.includes(scope)) : true;
  const status = determineStatus(hasAccess, isVisible, false);
  return {
    hasAccess,
    isVisible,
    missingSeats: [],
    missingPermissions: [],
    missingScopes,
    requireAllPermissions: false,
    status,
    isLoading: false
  };
}